import { useEffect } from "react";
declare global {
  interface Window {
    fbq?: (action: string, event: string, params?: Record<string, unknown>) => void;
    _fbq?: unknown;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) {
      window.fbq("track", "PageView");
      return;
    }
    const queuedPixel = (...args: unknown[]) => {
      (queuedPixel as typeof queuedPixel & {
        queue?: unknown[][];
      }).queue = [...((queuedPixel as typeof queuedPixel & {
        queue?: unknown[][];
      }).queue ?? []), args];
    };
    window.fbq = queuedPixel as unknown as (action: string, event: string, params?: Record<string, unknown>) => void;
    window._fbq = window.fbq;
    window.fbq("init", "1252242806993118");
    window.fbq("track", "PageView");
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(script);
    return () => script.remove();
  }, []);
  return null;
}